import Comments from './Comments';

import './Comments.scss';

export default Comments;
